// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3XZxn","col":"CardReaderDesc_col__2I6aF","label":"CardReaderDesc_label__1P6hK"};